export class User {
  username: 'anonymous';
  roles: string[] = [];

  hasAdminPermissions(): boolean {
    return this.roles.includes('ROLE_ADMIN');
  }

  hasEmbargoPermissions(): boolean {
    return this.roles.includes('ROLE_ADMIN') || this.roles.includes('ROLE_TEST_EMBARGO');
  }

  hasTestPermissions(): boolean {
    return this.roles.includes('ROLE_ADMIN') || this.roles.includes('ROLE_TEST_EMBARGO') || this.roles.includes('ROLE_TEST');
  }

  hasUploadPermissions(): boolean {
    return this.roles.includes('ROLE_UPLOAD');
  }
}
